/**
 * The employee packet creation application's own routes, mounted by the shell at /packets.
 *
 * Nothing in here knows it sits at /packets — the prefix is the shell's decision, recorded once in
 * `platform/registry.ts`.
 */
import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { DocumentFaceScope } from '@/theme/DocumentFaceScope';

const PacketsPage = lazy(() => import('@/apps/packets/PacketsPage'));
const PacketNewPage = lazy(() => import('@/apps/packets/PacketNewPage'));
const PacketPage = lazy(() => import('@/apps/packets/PacketPage'));
const PageLibraryPage = lazy(() => import('@/apps/packets/PageLibraryPage'));
const PageLibraryNewPage = lazy(() => import('@/apps/packets/PageLibraryNewPage'));

export const packetsRoutes = (
  <Route path="packets" element={<DocumentFaceScope />}>
    <Route index element={<PacketsPage />} />
    <Route path="new" element={<PacketNewPage />} />
    <Route path="library" element={<PageLibraryPage />} />
    <Route path="library/new" element={<PageLibraryNewPage />} />
    <Route path=":packetId" element={<PacketPage />} />
  </Route>
);
